import React, {useState} from "react";
import {serverRequest} from "../../../util/server_request";
import { useLocation, useNavigate } from 'react-router-dom';
import {notifyUser} from "../../../util/util";
import {Spin} from "antd";

export const OneTimePin = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // Always keep E.164 (233XXXXXXXXX) for backend, 0XXXXXXXXX for display
    const rawPhone = location.state?.phone;
    const displayPhone = rawPhone && rawPhone.startsWith('233') && rawPhone.length === 12
        ? '0' + rawPhone.slice(3)
        : rawPhone;
    const backendPhone = rawPhone;
    const employerNumber = location.state?.employerNumber;

    const [otp, setOTP] = useState('');
    const [loading, setLoading] = useState(false);

    const toggleLoading = () => setLoading(prevState => !prevState);

    const changeHandler = (e) => setOTP(e.target.value);

    // Always use backendPhone for API
    const verifyOTP = () => {
        if (!otp) {
            return notifyUser('error', 'Please enter OTP received to proceed!', 'Validation Error');
        }
        toggleLoading();
        serverRequest('GET', `auth/verify/phone/otp?otp=${otp}&phone=${backendPhone}`)
            .then(result => {
                toggleLoading();
                if (!result?.success) {
                    notifyUser('error', result?.message, 'Error');
                } else {
                    navigate('/onboard/validate-info', { state: { phone: backendPhone, employerNumber } });
                }
            }).catch(error => {
                toggleLoading();
                notifyUser('error', error.message, 'Error');
            });
    };

    // rerTriggerOTP removed as it is unused

    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Enter your One Time Pin</p>
                <small className='text-center'>We’ll send a One-Time Pin(OTP) to this number {displayPhone}.</small>

                <Spin spinning={loading}>
                    <div className="mt-4 w-75 mx-auto mobile-full-width">
                        <omk-otp-field
                            number-of-inputs="6"
                            resend-text=""
                            resend-button-label=""
                            label="One-time Password"
                            className='mb-2' value={otp} onInput={changeHandler} />
                        {/*<p className='mb-0' style={{ cursor: 'pointer', paddingBottom: '10px' }} onClick={rerTriggerOTP}>
                            Didn't receive OTP? <span style={{ color: '#009677', fontWeight: 'bold' }}>Resend</span>
                        </p>*/}
                        <p className="text-center omk-text-small text-black-50 mb-5"><i className="bi bi-shield-lock"/> Your information is confidential and secure</p>
                        <button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={verifyOTP}>Continue</button>
                    </div>
                </Spin>
            </div>
        </div>
    );
}